import React from "react";
import "./styles.scss";

const IconError: React.FC = () => {
  return <button className="icon-error" />;
};

export default IconError;
